import Vue from 'vue'
import VueResource from 'vue-resource'
import App from './App'
import 'whatwg-fetch'

require('leaflet')
require('@mapbox/leaflet-omnivore')
require('leaflet-routing-machine')
require('../vendor/js/lrm-google')
require('leaflet.markercluster')

Vue.use(VueResource)

/* eslint-disable no-new */
new Vue({
  el: '#app',
  render: h => h(App)
})



// WEBPACK FOOTER //
// ./src/main.js